import { useOutletContext } from "react-router-dom";
// import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadSessions = async () => {
  try {
    const response = await Axios.get('sessions');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};

export const isSessionClosed = async (error, id) => {
  try {
    const response = await Axios.post('sessions/pos/', {session_id: id});
    const responseData = await response.data;
    // console.log(responseData)
    if (responseData) {
      
      localStorage.setItem('caspian_pos_tax', JSON.stringify(responseData));
    }
  }catch (err) {
    if (err.code === 'ERR_NETWORK') {
      error("Couldn't process request. Please check your network connectivity");
    }else if (err?.response?.status === 307) {
      error(err.response.data.message);
      setTimeout(() => {
        window.location.href = '/pos';
      }, 2000);
    }
    throw err;
  }
};


export const loadSession = async (number) => {
  try {
    const respnse = await Axios.get('sessions/find/'+number);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}


export const loadSessionTransfers = async (number) => {
  try {
    const respnse = await Axios.get('sessions/transfers/'+number);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadSessionPayments = async (number) => {
  try {
    const respnse = await Axios.get('sessions/payments/'+number);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

// export const loadPos = async (action) => {
//   try {
//     switch (action) {
//       case 'new':
//         const response = await Axios.get('setups/sessions');
//         const responseData = await response.data;
//         return {...responseData, pos: {}};
//         // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
//       default:
//         const data = await loadOne(action);
//         return data;
//     }
//   }catch (err) {
//     throw err;
//   }
// }

const useSessionAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('sessions', data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('pos_response', data.seo);
      return responseData.data;
    }catch(err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        console.log(err)
        error(err.response?.data?.message);
      }
      throw err;
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('sessions/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('pos_response', data.seo);
    }catch (err) {
      throw err;
    }
  }
  const closeSession = async (seo, data, error, success) => {
    try {
      const respnse = await Axios.patch('sessions/close/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('pos_response', data.seo);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response?.data?.message);
      }
      console.log(err);
    }
  }

  return { create, update, closeSession };
};



export default useSessionAPI;


